import PolicyLayout, { PolicySection } from "@/components/policy/PolicyLayout";

export default function ShippingPolicy() {
  return (
    <PolicyLayout
      testId="shipping-policy-page"
      overline="Care · Policies"
      title="Shipping"
      italicWord="Policy."
      updated="July 2026"
      intro="Every Innayaa order is packaged in our signature keepsake box and dispatched with care from our studio in India. Here is what to expect when your piece is on its way."
    >
      <PolicySection n="1" title="Shipping Coverage">
        <p>
          We currently ship <strong className="text-[#2A2626]">across India</strong> to all
          pincodes serviceable by our logistics partners. International shipping is not
          available at this time — we&rsquo;re working on it and will announce when it goes live.
        </p>
      </PolicySection>

      <PolicySection n="2" title="Shipping Charges">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong className="text-[#2A2626]">Complimentary shipping</strong> on all orders
            of <strong className="text-[#2A2626]">₹4,000 and above</strong>.
          </li>
          <li>A flat shipping charge of <strong className="text-[#2A2626]">₹150</strong> applies to orders below ₹4,000.</li>
        </ul>
      </PolicySection>

      <PolicySection n="3" title="Order Processing Time">
        <p>
          Because every Innayaa piece is handcrafted, we take a little extra care before
          it leaves the studio.
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Orders are processed and dispatched within{" "}
            <strong className="text-[#2A2626]">2 to 3 working days</strong> of the order
            being placed.
          </li>
          <li>Orders placed on Sundays or public holidays are processed on the next working day.</li>
          <li>
            You will receive an order confirmation email at the address provided at checkout,
            followed by a dispatch notification with tracking details when your parcel leaves us.
          </li>
        </ul>
      </PolicySection>

      <PolicySection n="4" title="Delivery Timelines">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong className="text-[#2A2626]">Metro cities:</strong> 3 to 5 working days after
            dispatch.
          </li>
          <li>
            <strong className="text-[#2A2626]">Other cities &amp; towns:</strong> 5 to 8 working days
            after dispatch.
          </li>
          <li>
            <strong className="text-[#2A2626]">Remote pincodes:</strong> up to 10 working days
            after dispatch.
          </li>
        </ul>
        <p>
          Delivery timelines are indicative and may vary due to courier partner capacity,
          public holidays, weather, or other events outside our control.
        </p>
      </PolicySection>

      <PolicySection n="5" title="Order Tracking">
        <p>
          Once your order is dispatched, you&rsquo;ll receive a tracking link over email. If you
          haven&rsquo;t received the tracking details within 3 working days of placing your order,
          please write to us at{" "}
          <a href="mailto:innayaaofficial@gmail.com" className="text-[#2A2626] link-underline">
            innayaaofficial@gmail.com
          </a>{" "}
          with your Order Number and we&rsquo;ll help.
        </p>
      </PolicySection>

      <PolicySection n="6" title="Address Changes & Failed Deliveries">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Address changes can only be accommodated <strong className="text-[#2A2626]">before dispatch</strong>. Please email us with your Order Number as soon as possible if you need to update your shipping address.
          </li>
          <li>
            If a delivery attempt fails due to an incorrect address or an unavailable
            recipient, the parcel returns to our studio. Reshipping charges may
            apply for a second delivery attempt.
          </li>
        </ul>
      </PolicySection>

      <PolicySection n="7" title="Damaged or Missing Parcels">
        <p>
          If your parcel arrives damaged or tampered with, please <strong className="text-[#2A2626]">record an unboxing video</strong> before opening and share it with us within{" "}
          <strong className="text-[#2A2626]">48 hours of delivery</strong>. Please refer to our{" "}
          <a href="/return-exchange-policy" className="text-[#2A2626] link-underline">
            Return &amp; Exchange Policy
          </a>{" "}
          for the full process.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
